import React, {Component} from 'react';
import {Decimal} from 'decimal.js';
import TotalItem from "./TotalItem";
import NumberFormat from "react-number-format";
import SweetAlert from 'react-bootstrap-sweetalert';
import {checkNavlun} from "../../../helper/permission";

class TotalList extends Component{
    constructor(props) {
        super(props);
        this.state = {
            manualCheck: false,
            label:"",
            value:"",
            totalKdv0Amount:"",
            totalKdv1Amount:"",
            totalKdv8Amount:"",
            totalKdv10Amount:"",
            totalKdv18Amount:"",
            totalKdv20Amount:"",
            alertManuelCheck:false,
        };
        this.getTaxTotal = this.getTaxTotal.bind(this);
        this.totalKDVDisplay = this.totalKDVDisplay.bind(this);
        this.changeChargeValue = this.changeChargeValue.bind(this);
        this.onManualCheck = this.onManualCheck.bind(this);
        this.netAmountDisplay= this.netAmountDisplay.bind(this);
        this.calculateTotalStopage=this.calculateTotalStopage.bind(this);
        this.calculateTotalCarriageValueAmount = this.calculateTotalCarriageValueAmount.bind(this);
        this.calculateTotalInsuranceValueAmount = this.calculateTotalInsuranceValueAmount.bind(this);
        this.manuelCheckAlertConfirm = this.manuelCheckAlertConfirm.bind(this);
    }

    componentDidMount(){
        this.setState({manualCheck:this.props.isManual});
    }

    onManualCheck(e) {
        let checked = e.target.checked;
        if (!checked){
            this.props.changeKDV("totalKdv0Amount",null);
            this.props.changeKDV("totalKdv1Amount",null);
            this.props.changeKDV("totalKdv8Amount",null);
            this.props.changeKDV("totalKdv10Amount",null);
            this.props.changeKDV("totalKdv18Amount",null);
            this.props.changeKDV("totalKdv20Amount",null);
        } else{

            this.props.changeKDV("totalKdv0Amount",this.state.totalKdv0Amount);
            this.props.changeKDV("totalKdv1Amount",this.state.totalKdv1Amount);
            this.props.changeKDV("totalKdv8Amount",this.state.totalKdv8Amount);
            this.props.changeKDV("totalKdv10Amount",this.state.totalKdv10Amount);
            this.props.changeKDV("totalKdv18Amount",this.state.totalKdv18Amount);
            this.props.changeKDV("totalKdv20Amount",this.state.totalKdv20Amount);

            let lines  = this.props.lines;
            let chargeList = {};
            let total = 0;
            for (let i = 0; i < lines.length; i++) {
                let charges = lines[i][this.props.chargesName];
                for(let j=0; j<charges.length; j++){
                    let charge = charges[j];
                    if (charge.taxCode.code === "0015"){
                        if(typeof chargeList[charge.percentage] === 'undefined') {
                            chargeList[charge.percentage] = charge.amount;
                        }else {
                            chargeList[charge.percentage] += charge.amount;
                        }
                        total += charge.amount;
                    }
                }
            }

            for (let prop in chargeList) {
                this.changeChargeValue({name:"totalKdv" + prop + "Amount",value:chargeList[prop]});
            }
            this.setState({alertManuelCheck:true});
        }
        this.setState({ manualCheck: checked});
        if(this.props.type === "invoice" || this.props.type === "voucher")
            this.props.changeKDV("isManual",checked);
    }

    calculateTotalStopage(){
        let lines  = this.props.lines;
        let itemResult=0;
        let total = 0;
        let code="0003";
        let barSpecificVoucher=false;
        for (let i = 0; i < lines.length; i++) {
            itemResult = 0;
            barSpecificVoucher = (lines[i].itemName && lines[i].itemName.includes('Avukatlık Ücreti')) ||
                (lines[i].itemName && lines[i].itemName.includes('Vekalet Ücreti')) ||
                (lines[i].itemName && lines[i].itemName.includes('Arabuluculuk Ücreti'));
            let charges = lines[i][this.props.chargesName];
            for (let j = 0; j < charges.length; j++) {
                let charge = charges[j];
                if (charge.taxCode.code === code) {
                    itemResult = lines[i].lineExtensionAmount - charge.amount;
                    if (barSpecificVoucher && this.props.barStandardVoucherContent) {
                        for (const item of this.props.barStandardVoucherContent) {
                            if ((item.brut === lines[i].lineExtensionAmount) &&
                                (item.kdvAmount === lines[i].trdDocVoucherLineCharges.filter((charge => charge.taxCode.code === "0015"))[0].amount)) {
                                itemResult = item.net;
                                break;
                            }
                        }
                    }
                    total += itemResult;
                }
            }
        }
        return total;
    }

    getTaxTotal(code, label){
        let lines  = this.props.lines;
        let chargeList = {};
        let total = 0;
        for (let i = 0; i < lines.length; i++) {
            let charges = lines[i][this.props.chargesName];
            for(let j=0; j<charges.length; j++){
                let charge = charges[j];
                if (code === "0000") {
                    if (charge.taxCode.code === "0000" || charge.taxCode.code === "0001"  || charge.taxCode.code === "2001"
                        || charge.taxCode.code === "2002" || charge.taxCode.code === "2003" || charge.taxCode.code === "2004"
                        || charge.taxCode.code === "2005" || charge.taxCode.code === "3001" || charge.taxCode.constructor === "3002") {
                        if (typeof chargeList[charge.percentage] === 'undefined') {
                            chargeList[charge.percentage] = charge.amount;
                        } else {
                            chargeList[charge.percentage] += charge.amount;
                        }
                        if (charge.taxCode.code === "0001" || charge.taxCode.code === "3001" || charge.taxCode.constructor === "3002")
                            total -= charge.amount;
                        else
                            total += charge.amount;
                    }
                } else {
                    if (charge.taxCode.code === code) {
                        if (typeof chargeList[charge.percentage] === 'undefined') {
                            chargeList[charge.percentage] = charge.amount;
                        } else {
                            chargeList[charge.percentage] += charge.amount;
                        }
                        total += charge.amount;
                    }
                }
            }
        }

        Object.keys(chargeList).forEach(key => {
            if(chargeList[key] === '' || chargeList[key] === null ){
                chargeList[key] = 0;
            }
        });

        let chargeListStr = "";
        for (let key in chargeList) {
            if (key === "" || key === "null")
                chargeListStr += '%'+ '0.00' +'='+ '0.00' +', ';
            else
                chargeListStr += '%'+ (new Decimal(key).toFixed(2)) +'='+ (new Decimal(chargeList[key]).toFixed(2)) +', ';
        }
        chargeListStr = chargeListStr.substring(0, chargeListStr.length - 2);
        chargeListStr = (new Decimal(total).toFixed(2))+this.props.suffix +" ( "+ chargeListStr + " ) ";

        return (

            <div className="row">
                <label className="col-sm-6 col-form-label">{label}</label>
                <div className="col-sm-6">
                    <div className="form-group">
                        <textarea disabled={true} style={{width:'100%', paddingBottom:'inherit'}} value={chargeListStr}/>
                    </div>
                </div>
            </div>
        );
    }

    changeChargeValue(e) {
        const {name,value} = e;
        if(this.props.type === "invoice" || this.props.type === "voucher")
            this.props.changeKDV(name,value);
    }

    totalKDVDisplay(code, label){
        let lines  = this.props.lines;
        let chargeList = {};
        let total = 0;
        for (let i = 0; i < lines.length; i++) {
            let charges = lines[i][this.props.chargesName];
            for(let j=0; j<charges.length; j++){
                let charge = charges[j];
                if (charge.taxCode.code === code){
                    if (this.props.invoiceTypeCode !== 'TEVKIFATIADE') {
                        if(typeof chargeList[charge.percentage] === 'undefined') {
                            chargeList[charge.percentage] = charge.amount;
                        }else {
                            chargeList[charge.percentage] += charge.amount;
                        }
                        total += charge.amount;
                    } else {
                        if(typeof chargeList[charge.rateOfReturnedGood] === 'undefined') {
                            chargeList[charge.rateOfReturnedGood] = charge.vatRefundAmount;
                        }else if (chargeList[charge.rateOfReturnedGood] === null) {
                            chargeList[charge.rateOfReturnedGood] += 0;
                        }else {
                            chargeList[charge.rateOfReturnedGood] += charge.vatRefundAmount;
                        }
                        total += charge.vatRefundAmount;
                    }
                }
            }
        }

        let chargeList2 = [];
        for (let prop in chargeList) {
            chargeList2.push({label:prop,value:chargeList[prop]});
        }

        if (this.props.invoiceTypeCode !== 'TEVKIFATIADE') {
            return chargeList2.map((charge, index) =>

                (
                    <div className="row" key={index}>
                        <label className="col-sm-6 col-form-label">{this.props.invoiceTypeCode !== 'TEVKIFATIADE' ? "KDV( %" + charge.label +")" : "İadeye Konu KDV"}</label>
                        <div className="col-sm-6">
                            <div className="form-group">
                                <NumberFormat
                                    id={index}
                                    value={!this.state.manualCheck ? (charge.value) :
                                        ((this.props["totalKdv" + charge.label + "Amount"] !== null) ? (this.props["totalKdv" + charge.label + "Amount"]) : (charge.value))}
                                    allowNegative={false}
                                    isNumericString={true}
                                    disabled={!this.state.manualCheck ? true : false}
                                    suffix={this.props.suffix}
                                    decimalScale={2}
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                    displayType="input"
                                    isAllowed={values => {
                                        return (values.value === "" ? false : true);
                                    }}
                                    renderText={value => {
                                        value.replace(/\./g, ',')
                                    }}
                                    onValueChange={(e) => this.changeChargeValue({name: "totalKdv" + charge.label + "Amount",value:e.value})}
                                    // className="form-control text"
                                    className="form-control"
                                />
                            </div>
                        </div>
                    </div>
                )
            );
        } else {
            let chargeValue = 0;
            chargeList2.map((charge, index) => (
                chargeValue = chargeValue + charge.value
            ));
            let label = chargeList2[0].label;

            return (
                <div className="row" key={0}>
                    <label className="col-sm-6 col-form-label">{"İadeye Konu KDV"}</label>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <NumberFormat
                                id={0}
                                value={chargeValue}
                                allowNegative={false}
                                isNumericString={true}
                                disabled={!this.state.manualCheck ? true : false}
                                suffix={this.props.suffix}
                                decimalScale={2}
                                thousandSeparator={'.'}
                                decimalSeparator={','}
                                displayType="input"
                                isAllowed={values => {
                                    return (values.value === "" ? false : true);
                                }}
                                renderText={value => {
                                    value.replace(/\./g, ',')
                                }}
                                onValueChange={(e) => this.changeChargeValue({
                                    name: "totalKdv" + label + "Amount",
                                    value: e.value
                                })}
                                // className="form-control text"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>);
        }
    }

    netAmountDisplay(){
        let netAmount = this.calculateTotalStopage();

        return (
            <div className="row">
                <label className={"col-sm-"+ 6 +" col-form-label"}>{"Net Ücret Tutarı"}</label>
                <div className={"col-sm-"+ 6}>
                    <div className="form-group">
                        <NumberFormat value={netAmount}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      disabled={this.props.disabled === undefined ? true : this.props.disabled}
                                      isAllowed={values => {
                                          return (values.value === "" ? false : true);
                                      }}
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix={this.props.suffix}
                                      displayType={"input"}
                                      className="form-control"/>
                    </div>
                </div>
            </div>
        );
    }

    calculateTotalCarriageValueAmount(){
        let value=0;
        if(this.props.lines) {
            for (let i = 0; i < this.props.lines.length; i++) {
                let deliveryDetail = this.props.lines[i]["trdDocInvoiceLineDeliveryDetail"];
                if (deliveryDetail && checkNavlun(deliveryDetail["deliveryTerms"]) && deliveryDetail["declaredForCarriageValueAmount"])
                    value = new Decimal(value).add(new Decimal(deliveryDetail["declaredForCarriageValueAmount"]).toFixed(2)).toNumber();
            }
        }

        return (
            <div className="row">
                <label className={"col-sm-"+ 6 +" col-form-label"}>{"Navlun"}</label>
                <div className={"col-sm-"+ 6}>
                    <div className="form-group">
                        <NumberFormat value={value}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      disabled={this.props.disabled === undefined ? true : this.props.disabled}
                                      isAllowed={values => {
                                          return (values.value === "" ? false : true);
                                      }}
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix={this.props.suffix}
                                      displayType={"input"}
                                      className="form-control"/>
                    </div>
                </div>
            </div>
        );

    }

    calculateTotalInsuranceValueAmount(){
        let value=0;
        if(this.props.lines) {
            for (let i = 0; i < this.props.lines.length; i++) {
                let deliveryDetail = this.props.lines[i]["trdDocInvoiceLineDeliveryDetail"];
                if (deliveryDetail &&
                    checkNavlun(deliveryDetail["deliveryTerms"]) &&
                    deliveryDetail["insuranceValueAmount"])
                    value = new Decimal(value).add(new Decimal(deliveryDetail["insuranceValueAmount"]).toFixed(2)).toNumber();
            }
        }

        return (
            <div className="row">
                <label className={"col-sm-"+ 6 +" col-form-label"}>{"Sigorta"}</label>
                <div className={"col-sm-"+ 6}>
                    <div className="form-group">
                        <NumberFormat value={value}
                                      allowNegative={false}
                                      isNumericString={true}
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      thousandSeparator={'.'}
                                      decimalSeparator={','}
                                      disabled={this.props.disabled === undefined ? true : this.props.disabled}
                                      isAllowed={values => {
                                          return (values.value === "" ? false : true);
                                      }}
                                      renderText={value => {
                                          value.replace(/\./g, ',')
                                      }}
                                      suffix={this.props.suffix}
                                      displayType={"input"}
                                      className="form-control"/>
                    </div>
                </div>
            </div>
        );

    }

    manuelCheckAlertConfirm(){
        let self = this;
        self.setState({alertManuelCheck:false});
    }

    showManuelCheckAlert() {
        return <SweetAlert warning
                           title={"Lütfen kalem bilgilerinizi kontrol ediniz. Manuel giriş kullanırsanız kalem değişiklikleriniz toplamlar bölümüne yansımayacaktır."}
                           confirmBtnText="Tamam"
                           onConfirm={this.manuelCheckAlertConfirm}/>
    }

    render(){
        return (
            <div>
                {this.state.alertManuelCheck &&
                    this.showManuelCheckAlert()
                }
                <TotalItem label={this.props.invoiceTypeCode === undefined || this.props.invoiceTypeCode !== 'TEVKIFATIADE' ? "Ürün/Hizmet Tutar" : "İadeye Konu İşlem Bedeli Tutarı"} value={this.props.lineExtensionAmount} suffix={this.props.suffix} size={{lSize:6,dSize:6}}/>
                {this.props.showATA  && this.getTaxTotal("0000", "İskonto Tutar")}
                {this.props.showKDV  && this.totalKDVDisplay("0015","KDV Tutarı")}
                {this.props.showKDVT && this.getTaxTotal("9015","KDV Tevkifatı")}
                {this.props.showGVS  && this.getTaxTotal("0003","GV Stopajı")}
                {this.props.showNet  && this.netAmountDisplay()}
                {this.props.isExport && this.calculateTotalCarriageValueAmount()}
                {this.props.isExport && this.calculateTotalInsuranceValueAmount()}
                <TotalItem label={"Vergiler Hariç Tutar"}
                           disabled={!this.state.manualCheck}
                           name="taxExclusiveAmount"
                           changeChargeValue = {this.changeChargeValue}
                           value={this.props.taxExclusiveAmount}
                           suffix={this.props.suffix}
                           size={{lSize:6,dSize:6}}/>
                <TotalItem label={"Vergiler Dahil Tutar"}
                           disabled={!this.state.manualCheck}
                           name="taxInclusiveAmount"
                           changeChargeValue = {this.changeChargeValue}
                           value={this.props.taxInclusiveAmount}
                           suffix={this.props.suffix} size={{lSize:6,dSize:6}}/>
                {this.props.showTotalCosts &&
                <TotalItem label={"Toplam Masraflar"}
                           disabled={!this.state.manualCheck}
                           name="totalCosts"
                           changeChargeValue={this.changeChargeValue}
                           value={this.props.totalCosts ? this.props.totalCosts : 0}
                           suffix={this.props.suffix} size={{lSize: 6, dSize: 6}}/>
                }
                <TotalItem label={"Ödenecek Tutar"}
                           disabled={!this.state.manualCheck}
                           name="payableAmount"
                           changeChargeValue = {this.changeChargeValue}
                           value={this.props.payableAmount}
                           suffix={this.props.suffix}
                           size={{lSize:6,dSize:6}}/>
                {(this.props.type === "invoice" || this.props.type === "voucher") &&
                <div className="row">
                    <label className="col-sm-6 col-form-label">Manuel Giriş</label>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <input type="checkbox" checked={this.state.manualCheck} onChange={this.onManualCheck}/>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }
}

export default TotalList;